import { Button, Col, message, Row, Typography } from 'antd'
import React, { useEffect } from 'react'
import { handleMyTax } from '../../../helper'
import './SelfEmployedStatus.css'
import { useMutatePartnerProfile } from '../../../api/react-query/partners'
import { useStores } from '../../../Store/Store'
import KuperLink from '../../../components/UI/KuperLink'

const { Title } = Typography

export default function ChangeFioSMZ ({ loading, handleUpdateScreen }) {
  const { partnerProfile } = useStores()

  const {
    mutate: updatePartnerProfile,
    data: dataUpdatePartnerProfile,
    isSuccess: isSuccessUpdatePartnerProfile,
    isError: isErrorUpdatePartnerProfile,
    isLoading: isLoadingUpdatePartnerProfile
  } = useMutatePartnerProfile()

  useEffect(() => {
    if (isSuccessUpdatePartnerProfile && dataUpdatePartnerProfile?.isSuccess) {
      message.success('Запрос отправлен')
      partnerProfile.setPartnerProfile({
        ...dataUpdatePartnerProfile,
        ...(partnerProfile?.id ? { id: partnerProfile?.id } : {})
      })
      handleUpdateScreen && handleUpdateScreen(dataUpdatePartnerProfile?.profile)
    } else if (isErrorUpdatePartnerProfile || dataUpdatePartnerProfile?.errorMessage) {
      message.error(dataUpdatePartnerProfile?.errorMessage || 'Ошибка запроса проверки статуса')
    }
  }, [dataUpdatePartnerProfile, isSuccessUpdatePartnerProfile, isErrorUpdatePartnerProfile])

  const handleClick = () => {
    updatePartnerProfile({ info: {} })
  }

  return (
    <Row justify='space-between' className='selfEmployedStatus '>
      <Col span={24} className='info-block'>
        <Row>
          <Col span={24}>
            <Title level={3}>Остался последний шаг</Title>

            <p>
              Ваши данные в анкете и на сайте ФНС России не совпадают
            </p>
            <p>
              Измените ФИО в приложении "Мой налог" и нажмите "Готово" или заполните форму <KuperLink /> и укажите номер телефона из вашего аккаунта в «Мой налог», а затем ждите звонка оператора для завершения регистрации
            </p>
            <p>
              Если возникнут сложности, звоните: 8 800 250 54 50
            </p>

          </Col>
          <Col span={24} style={{ textAlign: 'center' }}>
            <img src='/img/pencil.png' className='pencil' />
          </Col>
        </Row>
      </Col>

      <Col span={24} className='btn-block'>
        <Button
          className='btn-my-tax'
          size='large'
          block
          onClick={handleMyTax}
        >
          <img src='/img/fns.png' className='mr-3' />Перейти в «Мой налог»
        </Button>
        <Button
          block
          ghost
          size='large'
          type='primary'
          className='margin-top-20 margin-bottom-20'
          onClick={handleClick}
          loading={loading || isLoadingUpdatePartnerProfile}
          style={{ width: '100%' }}
        >
          Готово
        </Button>
      </Col>
    </Row>
  )
}
